import { gql } from '@apollo/client';

export const QUESTIONNAIRES_QUERY = gql`
  query Questionnaires($pager: PagerInputNew, $filters: QuestionnaireFilterInput) {
    questionnaires(pager: $pager, filters: $filters) {
      total
      values {
        active
        code
        defaultYN
        filterFormula
        isHistory
        name
        questionnaireId
        validFrom
        validTo
        version
      }
    }
  }
`;

export const QUESTIONNAIRE_QUERY = gql`
  query Questionnaire($questionnaireId: Int!) {
    questionnaire(questionnaireId: $questionnaireId) {
      active
      additionalParametersDataSource
      code
      defaultYN
      filterFormula
      isHistory
      name
      questionActions {
        formula
        questionActionId
        questionActionTypeId
        questionActionTypes {
          id
          name
        }
        questionnaireId
        siteId
      }
      questionnaireId
      questions {
        chQuestionId
        chQuestionSiteId
        formula
        generationId
        mandatory
        numericPrecision
        orderNo
        questionCode
        questionDetails {
          chQuestionDetailId
          chQuestionDetailSiteId
          generationId
          isDefault
          questionDetailCode
          questionDetailId
          questionId
          questionValue
          questionScore
          siteId
        }
        questionId
        questionName
        questionTypeId
        questionnaireId
        readOnly
        siteId
      }
      siteId
      validFrom
      validTo
      version
    }
  }
`;

export const QUESTIONTYPES_QUERY = gql`
  query QuestionTypes {
    questionTypes {
      id
      name
    }
  }
`;

export const QUESTIONACTIONTYPES_QUERY = gql`
  query Query {
    questionActionTypes {
      id
      name
    }
  }
`;

export const QUESTIONNAIRES_FILTERS_QUERY = gql`
  {
    questionnairesFilters @client {
      fullTextFilter {
        value
      }
      name {
        value
      }
      code {
        value
      }
    }
  }
`;
